module.exports = __webpack_public_path__ + "img/FrauenOasenAbend.53a93ca3.jpg";